import { render, staticRenderFns } from "./Bumble.vue?vue&type=template&id=16fb1584&scoped=true&"
import script from "./Bumble.vue?vue&type=script&lang=js&"
export * from "./Bumble.vue?vue&type=script&lang=js&"
import style0 from "./Bumble.vue?vue&type=style&index=0&id=16fb1584&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16fb1584",
  null
  
)

export default component.exports